import { useCallback } from 'react';

const usePreventFormSubmitOnEnter = () =>
  useCallback((e: any) => {
    if (e.keyCode === 13 || e.key === 'Enter') {
      e.preventDefault();
    }
  }, []);

export default usePreventFormSubmitOnEnter;
